import { Box, Heading, Text } from "@chakra-ui/react";

function BlockHeader({ title, description, ...rest }) {
  return (
    <Box paddingBlock="2" {...rest}>
      <Heading as="h2" size="md" marginBlock="1">
        {title}
      </Heading>
      <Text opacity="0.75" fontSize="sm">
        {description}
      </Text>
    </Box>
  );
}

export default BlockHeader;